import { render } from "./AdminExamResultManagement.vue?vue&type=template&id=3fc0e025&scoped=true"
import script from "./AdminExamResultManagement.vue?vue&type=script&lang=js"
export * from "./AdminExamResultManagement.vue?vue&type=script&lang=js"

import "./AdminExamResultManagement.vue?vue&type=style&index=0&id=3fc0e025&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc0e025"]])

export default __exports__